var exports = {
  "n4": "RestrictionsPanelContainer__TysylI",
};

module.exports = exports;
